import useOnMount from '@/hooks/useOnMount';
import { useRef, useState } from 'react';

export const useStickyButton = () => {
  const mainButtonRef = useRef<HTMLButtonElement>(null);
  const [showStickyButton, setShowStickyButton] = useState(false);

  useOnMount(() => {
    const checkMainButtonVisibility = () => {
      if (mainButtonRef.current) {
        const mainButtonPosition = mainButtonRef.current.getBoundingClientRect();

        // For payment page: only show sticky when button is scrolled past viewport
        const isScrolledPast = mainButtonPosition.top < 0;
        const isCompletelyBelowViewport = mainButtonPosition.top > window.innerHeight;

        setShowStickyButton(isScrolledPast || isCompletelyBelowViewport);
      }
    };

    window.addEventListener('scroll', checkMainButtonVisibility);
    window.addEventListener('resize', checkMainButtonVisibility);

    // Initial check
    checkMainButtonVisibility();

    return () => {
      window.removeEventListener('scroll', checkMainButtonVisibility);
      window.removeEventListener('resize', checkMainButtonVisibility);
    };
  });

  return { showStickyButton, mainButtonRef };
};

export default useStickyButton;
